import React, { Component } from 'react'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import Icon from "../icon/icon.component.jsx";
import ImageUploaderDropZone from "../image-uploader/dropzone.component.jsx";
import Image from "../image/image.component.jsx";
import ActionButton from "../button/actionbutton.component.jsx";
const uuidv4 = require('uuid/v4')

class InlineEditImage extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            value: this.props.value,
            image: this.props.value,
            imageId: this.props.value || '',
            endPoint: this.props.endPoint || '',
            field: this.props.field || '',
            imageField: this.props.imageField || '',
            images: this.props.value ? [this.props.value] : [],
            uniqueId: uuidv4(),
            editable: this.props.editable || false,
            editMode: false,
            hover: false,
            onChange: this.props.onChange || function () { },
            success: false,
        }
        this.handleUserSelectChange = this.handleUserSelectChange.bind(this)
        this.triggerEdit = this.triggerEdit.bind(this)
        this.save = this.save.bind(this)
        this.onMouseEnterHandler = this.onMouseEnterHandler.bind(this)
        this.onMouseLeaveHandler = this.onMouseLeaveHandler.bind(this)
        this.handleImageChange = this.handleImageChange.bind(this)
    }


    componentWillReceiveProps(nextProps) {
        this.setState({
            value: nextProps.value,
            image: nextProps.value,
            images: nextProps.value ? [nextProps.value] : [],
            imageId: nextProps.imageId || '',
            endPoint: nextProps.endPoint || '',
            field: nextProps.field || '',
        })
    }

    componentDidMount() { }

    onMouseEnterHandler() {
        this.setState({
            hover: true
        });
    }

    onMouseLeaveHandler() {
        this.setState({
            hover: false
        });
    }

    triggerEdit(event) {
        event?.preventDefault()
        this.setState({
            editMode: !this.state.editMode
        })
    }

    handleUserSelectChange(locationId) {
        this.setState({
            locationId: locationId,
        })
    }

    save(event) {
        event.preventDefault()
        AppContext.getApiClient().patch(this.state.endPoint, {
            [this.state.field]: this.state.imageId,
        }).then((r) => {
            this.setState({
                value: r.attributes[this.state.imageField],
                editMode: false,
                success: !r.error,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        success: false,
                    })
                }, 1500)
            })
        })
    }

    handleImageChange(images) {
        if (images.length > 0) {
            this.setState({
                images: images,
                image: images[0],
                imageId: images[0].id,
            })
        } else {
            this.setState({
                images: [],
                image: null,
                imageId: '',
            })
        }
    }

    render() {
        let image = <Image image={this.state.value} size="small" />
        if (this.state.editable) {
            let link = <a href={'#'} onClick={this.triggerEdit} onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler}>
                {image} {!this.state.success ? <Icon value={'pencil-alt'} className={'ml-1 ' + (!this.state.hover ? 'text-gray' : '')} /> :
                    <Icon value={'check'} className={'ml-1 ' + (!this.state.hover ? 'text-success short-fade-out' : '')} />}
            </a>
            image = <span>
                {link}
                <div className={"dropdown-menu p-4 " + (this.state.editMode ? 'show' : '')} style={{ width: '350px' }}>
                    <div className="w-100 m-0">
                        <ImageUploaderDropZone
                            onUpdateImageList={this.handleImageChange}
                            maxFiles={1}
                            images={this.state.images}
                        />
                    </div>
                    <p className="m-0 pt-2">
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.triggerEdit}>
                            <Icon value={"arrow-left"} />
                        </button>
                        <ActionButton className="btn btn-sm btn-outline-primary ml-2" onClick={this.save}>
                            <Icon value={"save"} />
                        </ActionButton>
                    </p>
                </div>
            </span>
        }

        return image
    }

}

export default InlineEditImage





// WEBPACK FOOTER //
// ./src/common/inline-edit/image.component.jsx